import ContainerPainel from 'components/container_painel';
import { HorizontalStepper } from 'components/shared/horizontal_stepper';
import React, { useState } from 'react';
import { ROUTES } from 'routes/constants';
import { PageTitle } from 'components/shared/page_title';
import { Box, Button, Stack } from '@mui/material';
import DataConfirmation from 'components/shared/data_confirmation';
import { FormButton, FormButtonType } from 'components/shared/form_button';
import { SnackbarFeedback } from 'components/shared/snackbar_feedback';
import { Modal } from 'components/shared/modal';
import { useConfirmData } from './useConfirmData';
import { useNavigate } from 'react-router-dom';
import { FormName, PostAnswersPayload } from 'api/answers/dtos/answers.dto';
import { postAnswers } from 'api/answers/answers.api';

const CreateConfirmSchoolFeeding: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [sucessModal, setSucessModal] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const data = useConfirmData();

  console.log('DATA', data);

  const handleSubmit = async () => {
    setLoading(true);
    const userAccessUuid = localStorage.getItem('userAccessUuid') ?? '';
    const institutionUuid = localStorage.getItem('institutionUuid') ?? '';
    const forms: PostAnswersPayload[] = [
      {
        formName: FormName.ALIMENTACAO_ESCOLAR_MUNICIPAL,
        referencedYear: 2025,
        userAccessUuid,
        institutionUuid,
        answer: {
          valueAppliedByPnaeResource:
            parseFloat(data.municipalApplied.replace(/[^\d.-]/g, '')) || 0,
          valueProvidedByPnae:
            parseFloat(data.municipalProvided.replace(/[^\d.-]/g, '')) || 0,
          productAquiredFromCnpjByPnaeResourceList: data.municipalCnpjProducts,
          productAquiredFromCpfByPnaeResourceList: data.municipalCpfProducts,
        },
      },
      {
        formName: FormName.ALIMENTACAO_ESCOLAR_ESTADUAL,
        referencedYear: 2025,
        userAccessUuid,
        institutionUuid,
        answer: {
          valueAppliedByPnaeResource:
            parseFloat(data.stateApplied.replace(/[^\d.-]/g, '')) || 0,
          valueProvidedByPnae:
            parseFloat(data.stateProvided.replace(/[^\d.-]/g, '')) || 0,
          productAquiredFromCnpjByPnaeResourceList: data.stateCnpjProducts,
          productAquiredFromCpfByPnaeResourceList: data.stateCpfProducts,
        },
      },
      {
        formName: FormName.ALIMENTACAO_ESCOLAR_FEDERAL,
        referencedYear: 2025,
        userAccessUuid,
        institutionUuid,
        answer: {
          valueAppliedByPnaeResource:
            parseFloat(data.federalApplied.replace(/[^\d.-]/g, '')) || 0,
          valueProvidedByPnae:
            parseFloat(data.federalProvided.replace(/[^\d.-]/g, '')) || 0,
          productAquiredFromCnpjByPnaeResourceList: data.federalCnpjProducts,
          productAquiredFromCpfByPnaeResourceList: data.federalCpfProducts,
        },
      },
    ];
    try {
      for (const payload of forms) {
        await postAnswers(payload);
      }

      setSucessModal(true);
    } catch (error) {
      console.error(error);
      setErrorMessage(
        'Erro ao enviar os dados da Alimentação Escolar (Federal, Estadual ou Municipal).',
      );
    } finally {
      setLoading(false);
    }
  };



  return (
    <ContainerPainel
      pagina='CIFA - Cadastrar Município - 2025'
      showBackButton={true}
      backButtonPath={ROUTES.CREATE_MUNICIPAL_SCHOOL_FEEDING_2025}
    >
      <HorizontalStepper activeStep={5} />

      <PageTitle
        title='Confirmação de Dados'
        subtitle='Confirme todas as informações que foram preenchidas, e altere-as caso necessário.'
      />

      <Stack marginX='4rem'>
        <DataConfirmation
          title='Assistência Técnica e Extensão Rural'
          subData={data.aterMunicipalPartnerList.map((partner: any) => ({
            data: [
              {
                title: `${partner.name.toUpperCase()} - Dados da parceria com a Instituição (ATER)`,
              },
              {
                label:
                  'Quantos beneficiários da Agricultura Familiar (unidade agro familiar) foram atendidos com ATER realizada pela instituição parceira no Município?',
                value: `${partner.numberOfBeneficiary}`,
              },
            ],
            ata: [
              {
                ...(partner.partnershipDocument && {
                  titlePDF: partner.partnershipDocument.name,
                  fileName: partner.partnershipDocument.name,
                  fileSize: '---',
                  label: 'Documento de Formalização da Parceria',
                  onView: () =>
                    window.open(`/files/${partner.partnershipDocument.uuid}`),
                }),
              },
              {
                ...(partner.ataCmdrsDocument && {
                  titlePDF: partner.ataCmdrsDocument.name,
                  fileName: partner.ataCmdrsDocument.name,
                  fileSize: '---',
                  label: 'Ata do CMDRS',
                  onView: () =>
                    window.open(`/files/${partner.ataCmdrsDocument.uuid}`),
                }),
              },
            ].filter(Boolean),
          }))}
        />

        <DataConfirmation
          title='Resumo'
          data={[
            {
              value: `${Number(data.aterExclusiveServiceMunicipality)}`,
              label:
                'Quantos beneficiários da Agricultura Familiar (unidade agro familiar) foram atendidos com ATER realizada exclusivamente pelo Município?',
            },
            {
              value: data.aterServiceByMunicipalPartner ? 'Sim' : 'Não',
              label:
                'Foi realizada parceria com instituição para execução da ATER?',
            },
            {
              value: data.aterMunicipalPartnerList
                .map((partner: any) => partner.name.toUpperCase())
                .join(', '),
              label: 'Instituições parceiras:',
            },
          ]}
        />

        <DataConfirmation
          title='Alimentação Escolar (PNAE Federal)'
          data={[
            {
              value: `R$ ${Number(data.federalProvided).toLocaleString(
                'pt-BR',
              )}`,
              label: 'Valor disponibilizado pelo PNAE Federal:',
            },
            {
              value: `R$ ${Number(data.federalApplied).toLocaleString(
                'pt-BR',
              )}`,
              label:
                'Valores totais aplicados pelo município na Alimentação Escolar oriundos de todo e qualquer fornecedor no ano de 2024:',
            },
          ]}
          dataProduct={[
            {
              title:
                'Produtos adquiridos via CNPJ (com recurso do PNAE Federal) - Valores Aplicados na Aquisição de Produtos',
              data: data.federalCnpjProducts.map((prod: any) => ({
                value: `R$ ${Number(prod.value).toLocaleString('pt-BR')}`,
                cnpjOrcpf: prod.identification,
                name: prod.name,
              })),
            },
            {
              title:
                'Produtos adquiridos via CPF (com recurso do PNAE Federal) - Valores Aplicados na Aquisição de Produtos',
              data: data.federalCpfProducts.map((prod: any) => ({
                value: `R$ ${Number(prod.value).toLocaleString('pt-BR')}`,
                cnpjOrcpf: prod.identification,
                name: prod.name,
              })),
            },
          ]}
        />

        <DataConfirmation
          title='Alimentação Escolar (Governo Estadual)'
          data={[
            {
              value: `R$ ${Number(data.stateProvided).toLocaleString('pt-BR')}`,
              label: 'Valor disponibilizado pelo Governo Estadual:',
            },
            {
              value: `R$ ${Number(data.stateApplied).toLocaleString('pt-BR')}`,
              label:
                'Valores totais aplicados pelo município na Alimentação Escolar oriundos de todo e qualquer fornecedor no ano de 2024:',
            },
          ]}
          dataProduct={[
            {
              title:
                'Produtos adquiridos via CNPJ (com recurso do Governo Estadual)',
              data: data.stateCnpjProducts.map((item: any) => ({
                value: `R$ ${Number(item.value).toLocaleString('pt-BR')}`,
                cnpjOrcpf: item.identification,
                name: item.name,
              })),
            },
            {
              title:
                'Produtos adquiridos via CPF (com recurso do Governo Estadual)',
              data: data.stateCpfProducts.map((item: any) => ({
                value: `R$ ${Number(item.value).toLocaleString('pt-BR')}`,
                cnpjOrcpf: item.identification,
                name: item.name,
              })),
            },
          ]}
        />

        <DataConfirmation
          title='Alimentação Escolar (Prefeitura)'
          data={[
            {
              label: 'Valor disponibilizado pelo Prefeitura:',
              value: `R$ ${Number(data.municipalProvided).toLocaleString(
                'pt-BR',
              )}`,
            },
            {
              label:
                'Valores totais aplicados pelo município na Alimentação Escolar oriundos de todo e qualquer fornecedor no ano de 2024:',
              value: `R$ ${Number(data.municipalApplied).toLocaleString(
                'pt-BR',
              )}`,

            },
          ]}
          dataProduct={[
            {
              title: 'Produtos adquiridos via CNPJ (com recurso do Prefeitura)',
              data: data.municipalCnpjProducts.map((item: any) => ({
                value: `R$ ${Number(item.value).toLocaleString('pt-BR')}`,
                cnpjOrcpf: item.identification,
                name: item.name,
              })),
            },
            {
              title: 'Produtos adquiridos via CPF (com recurso do Prefeitura)',
              data: data.municipalCpfProducts.map((item: any) => ({
                value: `R$ ${Number(item.value).toLocaleString('pt-BR')}`,
                cnpjOrcpf: item.identification,
                name: item.name,
              })),
            },
          ]}
        />
      </Stack>

      {/* Botões */}
      <Box
        marginTop='20px'
        gap={2}
        alignItems='center'
        justifyContent='center'
        display='flex'
      >
        <Button
          onClick={() => navigate(ROUTES.CIFA2025)}
          variant='text'
          sx={{
            fontWeight: 'bold',
            textTransform: 'uppercase',
            color: '#1976D2',
          }}
        >
          Voltar
        </Button>
        <Button
          variant='contained'
          disabled={loading}
          onClick={handleSubmit}
          sx={{
            fontWeight: 'bold',
            textTransform: 'uppercase',
            backgroundColor: '#0048B6',
            '&:hover': {
              backgroundColor: '#003399',
            },
          }}
        >
          Confirmar e salvar
        </Button>
      </Box>
      <Modal
        open={sucessModal}
        onClose={() => navigate(ROUTES.CIFA2025)}
        title='Sucesso ao cadastrar município!'
        subTitle='O município foi cadastrado com sucesso no CIFA 2025'
        buttons={[
          <FormButton
            key={1}
            title='Voltar para a tela inicial'
            type={FormButtonType.PRIMARY}
            onClick={() => navigate(ROUTES.CIFA2025)}
          />,
        ]}
      />
      {errorMessage && (
        <SnackbarFeedback isOpen message={errorMessage} type='error' />
      )}
    </ContainerPainel>
  );
};

export default CreateConfirmSchoolFeeding;
